import apiClient from "../../axios/apiClient";


export const getOccupationList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_OCCUPATIONLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Occupation`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_OCCUPATIONLIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_OCCUPATIONLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveOccupationData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_OCCUPATION_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Occupation`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_OCCUPATION_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_OCCUPATION_REJECTED", payload: error.response });
    }
  };
  

  export const getOccupationListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_OCCUPATIONLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Occupation/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_OCCUPATIONLISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_OCCUPATIONLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateOccupationData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_OCCUPATION_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Occupation/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_OCCUPATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_OCCUPATION_REJECTED", payload: error.response });
  }
};


export const updateOccupationStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_OCCUPATION_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Occupation-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_OCCUPATION_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_OCCUPATION_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteOccupationData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_OCCUPATION_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Occupation/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_OCCUPATION_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_OCCUPATION_REJECTED", payload: error.response });
  }
};